import React, { useCallback, useEffect, useState } from "react";
import { Box } from "@material-ui/core";
import Stepper from "@components/Stepper/Stepper";
import UserRegistrationContainer from "./components/user-registration/UserRegistrationContainer";
import {
  REGISTRATION_PROCCESS_STEPS,
  VERTIFICATION_METHOD_ENUM,
} from "./constants";
import { useRouter } from "next/router";
import { Helmet } from "react-helmet";
import { projectId } from "../../services/firebaseConfig.json";

const steps = [
  {
    step: 0,
  },
  {
    step: 1,
  },
  {
    step: 2,
  },
  {
    step: 3,
  },
];

export default function SignUpContainer({ countries }) {
  const router = useRouter();
  const [registrationStep, setRegistrationStep] = useState(
    REGISTRATION_PROCCESS_STEPS.step1
  );
  const [vertificationMethod, setVertificationMethod] = useState(null);
  const [isEditProfile, setIsEditProfile] = useState(false);

  useEffect(() => {
    document.title = "Sign Up | FruPro";
  }, []);
  const onGoBack = () => {
    if (registrationStep === 1) {
      router.push("/login");
    } else if (registrationStep === 2) {
      if (vertificationMethod === null) {
        setIsEditProfile(true);
        setRegistrationStep(REGISTRATION_PROCCESS_STEPS.step1);
      } else if (vertificationMethod === VERTIFICATION_METHOD_ENUM.SMS) {
        setVertificationMethod(null);
      } else if (vertificationMethod === VERTIFICATION_METHOD_ENUM.EMAIL) {
        setVertificationMethod(null);
      }
    }
  };

  const renderStepContent = () => {
    return (
      <UserRegistrationContainer
        isEditProfile={isEditProfile}
        setIsEditProfile={setIsEditProfile}
        registrationStep={registrationStep}
        setRegistrationStep={setRegistrationStep}
        vertificationMethod={vertificationMethod}
        setVertificationMethod={setVertificationMethod}
        countries={countries}
        onNextStep={onNextStep}
      />
    );
  };

  const onNextStep = () => {
    setRegistrationStep((prev) => prev + 1);
  };

  return (
    <>
      <Helmet>
        <title>
          {projectId === "frupro-staging"
            ? "🟡Sign Up | FruPro"
            : "Sign Up | FruPro"}
        </title>
      </Helmet>
      <Box component="main">
        <Box className="container">
          <Stepper
            vertificationMethod={vertificationMethod}
            onGoBack={onGoBack}
            steps={steps}
            activeStep={registrationStep - 1}
          >
            {renderStepContent()}
          </Stepper>
        </Box>
      </Box>
    </>
  );
}
